const LangES_ca = {
  legend: {
    selector: {
      all: 'Totes',
      inverse: 'Inversa',
    },
  },
  toolbox: {
    brush: {
      title: {
        rect: 'Selecció de quadre',
        polygon: 'Selecció de llaç',
        lineX: 'Seleccionar horitzontalment',
        lineY: 'Seleccionar verticalment',
        keep: 'Mantenir selecció',
        clear: 'Aclarir seleccions',
      },
    },
    dataView: {
      title: 'Veure dades',
      lang: ['Veure dades', 'Tancar', 'Actualitzar'],
    },
    dataZoom: {
      title: {
        zoom: 'Zoom',
        back: 'Restablir zoom',
      },
    },
    magicType: {
      title: {
        line: 'Canvia a gràfic de línies',
        bar: 'Canviar a gràfic de barres',
        stack: 'Pila',
        tiled: 'Teula',
      },
    },
    restore: {
      title: 'Restaurar',
    },
    saveAsImage: {
      title: 'Desa com a imatge',
      lang: ['Clic dret per desar imatge'],
    },
  },
};

export default LangES_ca;
